import { isWeb } from 'ui/src'

export const INSUFFICIENT_NATIVE_TOKEN_TEXT_VARIANT = isWeb ? 'body4' : 'body3'
